import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestArticles() {
  const latest = [...articles].sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat?.name || slug;
  };

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14" aria-label="最新文章">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最新八卦
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {latest.slice(0, 9).map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap backdrop-blur-sm">
                  {getCategoryName(article.category)}
                </span>
              </div>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200 mb-2">
                {article.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-400 flex-wrap gap-2">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center">
                    <i className="ri-user-line text-xs"></i>
                  </div>
                  <span>{article.author}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount > 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {latest.length > 9 && (
        <div className="flex justify-center mt-8">
          <button className="px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-semibold rounded-full transition-all duration-200 whitespace-nowrap text-sm cursor-pointer">
            加载更多
            <i className="ri-arrow-down-line ml-2"></i>
          </button>
        </div>
      )}
    </section>
  );
}